import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ScrollToLastPosition } from '@app/helper/scroll-to-last-position';
import { CacheObjectService, DeviceService, EventTrackerService } from '@app/core';
import { DomSanitizer } from '@angular/platform-browser';
import { IndicatorService } from '@app/shared';
import { CatalogService } from '@app/app/catalog/catalog.service';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { AppParametersService } from '@app/core/token/app-parameters.service';

@Component({
  selector: 'navaar-catalog-landing',
  templateUrl: './catalog-landing.component.html',
  styleUrls: ['./catalog-landing.component.scss']
})
export class CatalogLandingComponent extends ScrollToLastPosition implements OnInit {
  public subscription: Subscription = new Subscription();
  public description: string;
  public title: string;
  public listKey: string;
  public readonly PAGE_SIZE = 20;
  public total: number = 0;
  public skip: number = 0;
  public pages: number = 0;
  public isLoading: boolean = false;
  public isEnd: boolean = false;
  public items: Array<any> = [];

  public get pageNo(): number {
    return this.cache.pageNumer;
  }

  public set pageNo(v: number) {
    this.cache.pageNumer = v;
  }

  constructor(
    public readonly parametersService: AppParametersService,
    public readonly device: DeviceService,
    public readonly _dom: DomSanitizer,
    private readonly indicator: IndicatorService,
    private readonly catalogService: CatalogService,
    private readonly route: ActivatedRoute,
    private readonly cache: CacheObjectService<any>,
    private readonly chkd: ChangeDetectorRef,
    private readonly router: Router,
    private readonly eventTracker: EventTrackerService) {
    super(router);
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        if (event.restoredState)
          this.catalogService.isBackFromItem = true;
      });
  }

  public ngOnInit() {
    this.title = this.route.snapshot.queryParamMap.get('title');
    const key = this.route.snapshot.queryParamMap.get('key');
    if (key) {
      this.listKey = key;
      this.loadDescription(key);
      this.loadBookListNext();
    }
  }

  private loadDescription(deskKey: string) {
    if (deskKey) {
      this.cache.getObjectCache(`/api/audiobooks/catalog-type/${deskKey}`).subscribe(x => {
        this.description = x.description;
        this.indicator.hide();
        this.indicator.hideHude();
        this.chkd.detectChanges();
      });
    }
  }

  private async loadBookListNext() {
    this.isLoading = true;
    const clientId = this.parametersService.clientId;
    const url = `/api/indexitem/${this.listKey}/catalog-type-landing?clientId=${clientId}`;
    let Url = `${url}&$inlinecount=allpages`;
    if (this.skip != undefined) {
      Url += `&$skip=${this.skip}`;
    }
    if (this.PAGE_SIZE != undefined) {
      Url += `&$top=${this.PAGE_SIZE}`;
    }
    await this.cache.getObjectCacheOfList(Url, this.listKey, this.pageNo).pipe(
      map((res) => {
        this.isLoading = false;
        this.isEnd = res.items.length === res.total;
        this.items = res.items;
        this.total = res.total;
        this.pages = Math.ceil(this.total / this.PAGE_SIZE);
        this.indicator.hide();
        this.indicator.hideHude();
        this.chkd.detectChanges();
        return res;
      })
    ).toPromise();
    if (this.catalogService.isBackFromItem)
      super.scrollToPosition();
  }

  public goToPage(page: number) {
    this.paginate(page);
  }

  public paginate(page) {
    this.pageNo = page;
    this.skip = this.pageNo * this.PAGE_SIZE;
    this.catalogService.isBackFromItem = false;
    this.loadBookListNext().then();
  }
}
